import "./SetupToolsPanel.css"
import React from "react";
import editorService from "../../service/EditorService";
import {fileEditorStore} from "../../stores/FileEditorStore";
import {observer} from "mobx-react-lite";
import toolService, {CncTool, formatToolName} from "../../service/ToolService";
import {Button} from "primereact/button";
import {PaintData} from "../../service/Editor";


let count = 0
const expandedActive = {
    expanded: [false, false],
    active: [false, false],
}

function updateExpandedActive(expanded: boolean, active: boolean) {
    if (count % 2 == 0) {
        expandedActive.expanded[0] = expandedActive.expanded[1]
        expandedActive.expanded[1] = expanded
        expandedActive.active[0] = expandedActive.active[1]
        expandedActive.active[1] = active
    }
    count++
    if (count == 4) {
        count = 0
    }
}

function SetupToolsPanel() {
    let selectedFileName = fileEditorStore.selectedFileName;
    let paintData: PaintData

    updateExpandedActive(fileEditorStore.getSlidePanelExpanded(), fileEditorStore.isActive)

    // if (fileEditorStore.isActive && fileEditorStore.getSlidePanelExpanded()) {
    if (expandedActive.active[0]) {
        paintData = editorService.paintData()
    } else {
        paintData = {
            holes: [],
            routes: [],
            cuts: []
        }
    }

    const diametersMap: any = {}

    paintData.holes.forEach(h => {
        let diameterCount = diametersMap[h.diameter]
        if (diameterCount) {
            diametersMap[h.diameter]++
        } else {
            diametersMap[h.diameter] = 1
        }
    })

    let diameters = Object.keys(diametersMap).map(d => {
        return {
            diameter: d,
            count: diametersMap[d]
        }
    });

    let availableTools: Array<CncTool> = toolService.availableTools();

    function handleAdd() {
        toolService.addTool()
    }

    function handleRemove() {
        toolService.removeTool()
    }

    return (<>
        <div className={"content"}>
            <div className={"button-set"}>
                <Button onClick={handleAdd}>Add</Button>
                <Button onClick={handleRemove}>Remove</Button>
            </div>

            <h3>My tools</h3>
            {availableTools.map((cncTool: CncTool) =>
                <div key={cncTool.code}>
                    {formatToolName(cncTool)}
                </div>
            )}

            <h3>All holes diameters</h3>
            {diameters.map(en =>
                <>
                    <div key={en.count + "_" + en.diameter}>
                        <span>{en.diameter}</span>
                        <span>:</span>
                        <span>{en.count}</span>
                    </div>
                </>
            )}
        </div>
    </>)
}

export default observer(SetupToolsPanel)